// src/app/version.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';


@Injectable({
  providedIn: 'root'
})
export class InfoService {
  private infoUrl = '/info';

  constructor(private _http: HttpClient) {}

  getInfos(): Observable<any> {
    return this._http.get(environment.api + this.infoUrl);
  }

}
